import { IconGitFork } from '@u21/tabler-icons';
import { useSelector } from 'react-redux';
import { U21Chip, U21ChipProps } from 'app/shared/u21-ui/components';
import { ROUTES_MAP } from 'app/shared/utils/routes';
import { selectHasReadRulesPermission } from 'app/modules/session/selectors';
import { FlowTooltip } from 'app/modules/detectionModels/components/FlowTooltip';
import { RuleFlow } from 'app/modules/rules/types/responses';

interface Props extends Omit<Partial<U21ChipProps>, 'children'> {
  flow: Pick<RuleFlow, 'id' | 'status' | 'title'>;
}

export const FlowChip = (props: Props) => {
  const {
    flow: { id, status, title },
    ...rest
  } = props;
  const hasReadRulesPermission = useSelector(selectHasReadRulesPermission);
  const flowDetailPath = ROUTES_MAP.flowDetail.path
    .replace(':id', String(id))
    .replace('/:tab?', '');
  return (
    <U21Chip
      icon={<IconGitFork />}
      to={hasReadRulesPermission ? flowDetailPath : undefined}
      tooltip={<FlowTooltip id={id} title={title} status={status} />}
      {...rest}
    >
      {title}
    </U21Chip>
  );
};
